import { GeoLocationConfig } from '@wdpr/ra-angular-geolocation';

// This config should match the one on /src/static/server.ts
// GEO_CODE_URL == GET exposed in the server for geolocation
// GEO_CODE_COOKIE_NAME == geoConfig.cookieName
export const geoConfig: GeoLocationConfig = {
    GEO_CODE_URL: '/advanced-finder/geocode/',
    GEO_CODE_COOKIE_NAME: 'WDPROGeoIP'
};
